import styled from 'styled-components'
export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #276f87;
  color: white;
  font-size: 5rem;
`
